// Helper puro: mapea un jugador del shape del backend (countries.data.statistics)
// al shape que consume PlayerStatsCard.
//
// Backend (cada item):
//   { playerId, name, number, position, image, stats: [{ code, codeName, value }] }
//
// PlayerStatsCard:
//   { player: { name, number, image }, columns: [{ code, value, isHighlighted }] }
//
// Filosofía agnóstica: NO se mapean códigos, NO se rellenan columnas, NO se
// reordena. La data viene del backend en el orden y forma correctos; la card
// renderiza exactamente lo que llega.
//
// TODO: cuando el backend exponga un flag explícito para la stat principal
// (p.ej. stat.isPrimary), reemplazar la lógica de "index === 0" por ese flag.
export const mapPlayerToCardProps = rawPlayer => {
  const { name, number, image, stats = [] } = rawPlayer || {};
  return {
    player: { name, number, image },
    columns: stats.map((stat, index) => ({
      code: stat.code,
      value: stat.value,
      // Convención visual del Figma: la primera columna lleva el highlight
      // (suele ser la stat principal de la categoría — G ofensivo, I defensivo,
      // SV portero). El backend devuelve los stats en el orden correcto.
      isHighlighted: index === 0,
    })),
  };
};
